import { Plus } from "lucide-react";
import { columns } from "./columns";
import { useNavigate } from "react-router-dom";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { ComplaintsType, User } from "@/src/data/types";
import { Button } from "../../ui/button";
import { DataTable } from "../../ui/data-table";

interface ComplaintsProps {
  data: ComplaintsType[];
}

export const ComplaintsData: React.FC<ComplaintsProps> = ({ data }) => {
  const router = useNavigate();

  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Messages (${data.length})`}
          description="Gestion des messages "
        />
      </div>
      <Separator />
      <DataTable searchKey="name" columns={columns} data={data} />
    </>
  );
};
